// extracted by mini-css-extract-plugin
export default {"body_styleDefault":"c-a_fJ","body_styleRed":"c-a_fK"};